:host {
  --font-family: 'Montserrat', sans-serif;
  background-color: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;

    gz-link {
      --cursorType: pointer;
    }
  }
}
